import Keycloak from 'keycloak-js'

const initOptions = {
  //onLoad: 'login-required',
  useNonce: true,
  checkLoginIframe: false,
}

export async function connectKeycloak({ url, realm, clientId, refreshInSeconds = 30 } = {}) {
    const keycloakConfig = {
        url,
        realm,
        clientId
    }

    const keycloak = new Keycloak(keycloakConfig)

    return keycloak.init(initOptions)
    .then(authenticated => {
      if (authenticated) {
        setInterval(() => {
            if (keycloak.authenticated) {
                keycloak.updateToken(900)
                .catch(() => {
                    keycloak.logout()
                })
            }
        }, refreshInSeconds * 1000)
      }
      return keycloak
    })
}
